// The Hanabi game UI.

import { FADE_TIME_MS } from "../constants";
import { globals } from "../Globals";
import { tablesDraw } from "../lobby/tablesDraw";
import { Screen } from "../lobby/types/Screen";
import * as usersDraw from "../lobby/usersDraw";
import * as sounds from "../sounds";
import * as tooltips from "../tooltips";
import { getHTMLElement } from "../utils";
import * as chat from "./chat";
import { HanabiUI } from "./ui/HanabiUI";

const lobbyChatText = getHTMLElement("#lobby-chat-text");

export function init(): void {
  $("#game").on("mouseenter mouseleave", () => {
    if (globals.currentScreen === Screen.Game && globals.ui !== null) {
      globals.ui.focusLost();
    }
  });
}

export function show(): void {
  tooltips.clearPlayerTimeTooltips();
  globals.currentScreen = Screen.Game;
  document.body.dataset["screen"] = "game";
  $("#page-wrapper").hide(); // We can't fade this out as it will overlap
  $("#game-chat-text").html(""); // Clear the in-game chat box of any previous content
  // eslint-disable-next-line @typescript-eslint/strict-void-return
  $("body").on("contextmenu", () => false); // Disable the right-click context menu
  $("#game").fadeIn(FADE_TIME_MS);

  // Every time a new game is opened, the UI is rebuilt from scratch.
  globals.ui = new HanabiUI(globals, gameExports);
  globals.chatUnread = 0;

  // Request some high-level information about the game (e.g. the number of players and the variant)
  // The server will send us back an "init" message, which will contain enough information to start
  // drawing the UI (we will request the specific actions for the game later on)
  globals.conn!.send("getGameInfo1", {
    tableID: globals.tableID,
  });
}

function hide() {
  globals.currentScreen = Screen.Lobby;
  document.body.dataset["screen"] = "lobby";
  tablesDraw();
  usersDraw.draw();

  if (globals.ui !== null) {
    globals.ui.destroy();
    globals.ui = null;
  }

  $("#game").hide(); // We can't fade this out as it will overlap
  $("body").off("contextmenu"); // Enable the right-click context menu
  $("#page-wrapper").fadeIn(FADE_TIME_MS, () => {
    // Also account that we could be going back to one of the history screens. (We could have
    // entered a solo replay from one of the history screens.)
    if ($("#lobby-history").is(":visible")) {
      globals.currentScreen = Screen.History;
    } else if ($("#lobby-history-other-scores").is(":visible")) {
      globals.currentScreen = Screen.HistoryOtherScores;
    }
  });

  // Make sure that there are not any game-related modals showing.
  $("#game-chat-modal").hide();

  // Make sure that there are not any game-related tooltips showing.
  tooltips.closeAllTooltips();

  // Scroll to the bottom of the chat.
  lobbyChatText.scrollTop = lobbyChatText.scrollHeight;
}

// These are references to some functions and submodules that need to be interacted with in the UI
// code (e.g. hiding the UI, playing a sound).
export interface GameExports {
  hide: () => void;
  chat: typeof chat;
  sounds: typeof sounds;
}
const gameExports: GameExports = {
  hide,
  chat,
  sounds,
};
